import { TextField, useStyles, AuthGoogleLinkedin, Checkbox, combine } from '@webapps/styles';
import {
  useAuth,
  useRouter,
  useMutation,
  useToast,
} from '@webapps/reactjs-tech-components';
import { useFormik } from 'formik';
import { useLocation } from 'react-router-dom';
import * as yup from 'yup';
import MailConfirmation from './Components/MailConfirmation';
import InviteModale from './Components/InviteModale';
import { ROUTES_PATH } from 'config/constants';
import { createBusiness, createSchool } from '@webapps/business';
import { useState, useEffect } from 'react';
import Modal from 'components/Modal';
import ForgotPassword from './Components/ForgotPassword';
import Head from 'components/Head/Head';
// Test d'import du thème
import { linkpickTheme } from '@webapps/styles';
import NewModal from './Components/NewModal';
import theme from './theme';
import { Auth } from 'aws-amplify';
import { cognitoError } from 'config/constants';

const { NX_PROXY_API } = process.env;

const signInSchema = yup.object().shape({
  username: yup.string().email('E-mail Invalide').required('* Requis'),
  password: yup.string().required('* Requis'),
});

const {
  images: { CarrouselSign, PicsLogo, forgetPassword, Candidate },
} = theme;

export default function SignIn() {
  const { classes, theme } = useStyles(styles);

  const { push, searchParams } = useRouter();
  const location = useLocation();

  const { error, isLoading, login } = useAuth();

  const [showPassword, setShowPassword] = useState(false);
  const [viewMail, setViewMail] = useState(false);
  const [accType, setAccType] = useState(location?.state?.user || searchParams?.u || 'individual');
  const [forgotPassword, setForgotPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [rememberMe, setRememberMe] = useState(true);
  const [stepModal, setStepModal] = useState(1);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [showInviteModal, setShowInviteModal] = useState(searchParams?.accountCreated || false);
  const [forgotPasswordSubmit, setForgotPasswordSubmit] = useState(null);
  const [forgotPasswordEmail, setForgotPasswordEmail] = useState('');
  const [mailConfirmationSubmit, setMailConfirmationSubmit] = useState(null);
  const [isMailSuccess, setIsMailSuccess] = useState(false);
  console.log("🚀 ~ SignIn ~ mailConfirmationSubmit:", mailConfirmationSubmit)

  // Toast for success actions
  const { addToast } = useToast();

  // URL search params
  const query = new URLSearchParams(location.search);

  // Retrieve user email after payment success
  const email = query.get('email');

  // Retrieve customer id after payment success
  const id = query.get('id');

  const name = query.get('name');

  const rawPhone = query.get('phone');
  const phone = rawPhone && rawPhone.replace(/\s/g, '+');
  const password = query.get('key');
  const siret = query.get('siret');
  const type = query.get('type');
  const knowUs = query.get('knowUs');

  // Business account creation
  const {
    error: errorRegistrationBusiness,
    isLoading: mutateCreateBusinessLoading,
    isSuccess: mutateCreateBusinessSuccess,
    mutate: mutateCreateBusiness,
  } = useMutation(createBusiness, {
    onError: async (error) => {
      if (error.request.status === 409) {
        setErrorMessage(
          "L'e-mail ou le numéro de téléphone utilisé est déjà associé à un compte."
        );
      }
    },
  });

  // School account creation
  const {
    error: errorRegistrationSchool,
    isSuccess: mutateCreateSchoolSuccess,
    mutate: mutateCreateSchool,
  } = useMutation(createSchool, {
    onError: async (error) => {
      if (error.request.status === 409) {
        setErrorMessage(
          "L'e-mail ou le numéro de téléphone utilisé est déjà associé à un compte."
        );
      }
    },
  });

  // Add toast when when token is expired
  // Check LS on page load
  let tokenIsExpired = localStorage.getItem('expired');
  useEffect(() => {
    if (tokenIsExpired === "true") {
      addToast({
        status: 'error',
        autoDelete: false,
        message: (
          <div>Votre session a expiré, veuillez vous reconnecter</div>
        ),
      });
      localStorage.removeItem('expired');
    }
  }, []);

  // Afficher la modale si on vient de créer un compte
  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    if (urlParams.get('accountCreated') === 'true') {
      setShowInviteModal(true);
      // Nettoyer l'URL
      const newUrl = window.location.pathname;
      window.history.replaceState({}, '', newUrl);
    }
  }, [location.search]);

  // Subscribe to recurrent payment
  async function registerUser() {
    let amount = '';
    switch (type) {
      case 'business':
        amount = '3000';
        break;
      case 'school':
        amount = '30000';
        break;
    }

    // Create the Subscription to Gocardless, server call
    const res = await fetch(`${NX_PROXY_API}/goCardLess-subscribe`, {
      method: "POST",
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        sepaAmount: amount,
        userEmail: email,
        customerId: id,
        type: type,
      })
    });

    // Result of fetch subscription call
    const subscriptionRes = await res.json();

    // If gocardless subscription succeeds
    if (subscriptionRes.id !== null) {
      // Get mandate id, customer id & subscription id
      // Will be saved in database for subscription updates
      const customerId = subscriptionRes.metadata.customerId;
      const subscriptionId = subscriptionRes.id;
      const mandateId = subscriptionRes.links.mandate;

      // Retrieve customer data, used for address
      const res = await fetch(`${NX_PROXY_API}/getGoCardLessCustomer/${customerId}`, {
        method: "GET",
        headers: {
          'Content-Type': 'application/json'
        },
      });

      let address = "";
      let city = "";
      let code = "";

      // Define Address
      res.json().then((data) => {
        address = data.customer.address_line1;
        city = data.customer.city;
        code = data.customer.postal_code;

        // Define subscription data
        const subscription = 'Premium';
        const subscriptionEndDate = null;
        const paymentType = 'Gocardless';

        // Save in Database & Pennylane (School / Business)
        if (password !== "null" && type === 'school') {
          mutateCreateSchool({
            address,
            city,
            code,
            email,
            name,
            password,
            siret,
            phone,
            subscription, // Free or Premium
            sub_expiration: null,
            gocardlessMandateId: mandateId,
            gocardlessCustomerId: customerId,
            gocardlessSubscriptionId: subscriptionId,
            paymentType: paymentType, // Gocardless
            knowUs,
          });
        } else if (password !== "null" && type === 'business') {
          mutateCreateBusiness({
            address,
            city,
            code,
            email,
            name,
            password,
            siret,
            phone,
            subscription,
            sub_expiration: null,
            gocardlessMandateId: mandateId,
            gocardlessCustomerId: customerId,
            gocardlessSubscriptionId: subscriptionId,
            paymentType: paymentType, // Gocardless
            knowUs,
          });
        }
      });
    }
  }

  // Add toast when SEPA payment succeeds on account creation
  // Used after redirection when payment succeeds
  useEffect(() => {
    // If payment succeeds, create monthly subscription
    if (location.search.includes('payment=success')) {
      registerUser();
    }
  }, []);

  useEffect(() => {
    if (mutateCreateBusinessSuccess || mutateCreateSchoolSuccess) {
      setShowInviteModal(true);
      formik.resetForm();
    }
    else if (errorRegistrationBusiness || errorRegistrationSchool) {
      addToast({
        status: 'error',
        autoDelete: false,
        message: (
          <div>
            <div>Erreur lors de la création de votre compte</div>
            <div>Le paiement a été annulé</div>
          </div>
        ),
      });
    }
  }, [errorRegistrationBusiness, errorRegistrationSchool, mutateCreateBusinessSuccess, mutateCreateSchoolSuccess]);

  const goToSignup = () => {
    push(ROUTES_PATH.SIGN_UP, { from: { user: accType } });
  };

  const goToHome = () => {
    window.location.href = 'https://linkpick.fr/';
  };

  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleMouseDownPassword = () => setShowPassword(!showPassword);

  const handleForgotPasswordNext = (email) => {
    setForgotPasswordEmail(email);
    setStepModal(2);
  };

  const handleSendConfirmation = async (email) => {
    try {
      await Auth.resendSignUp(email);
      setIsMailSuccess(true);
    } catch (error) {
      addToast({
        status: 'error',
        message: cognitoError(error.code),
      });
    }
  };

  // Effect pour gérer le succès de l'envoi d'email
  useEffect(() => {
    if (isMailSuccess) {
      addToast({
        status: 'success',
        message: 'L\'email de vérification a été envoyé avec succès',
      });
      setViewMail(false);
      setIsMailSuccess(false); // Reset pour les prochaines utilisations
    }
  }, [isMailSuccess, addToast]);

  const formik = useFormik({
    initialValues: {
      username: '',
      password: '',
    },
    validationSchema: signInSchema,
    onSubmit: async ({ password, username }) => {
      await login({
        username,
        password,
      });
    }
  });

  console.log("🚀 ~ SignIn ~ forgotPasswordSubmit:", forgotPasswordSubmit);


  return (
    <>
      <Head
        subtitle="Une plateforme polyvalente dédiée à l'emploi et à la formation, ouverte à tous les acteurs du monde professionnel."
        title="Connexion"
      />
      <div className={classes["framerDiv"]}>
        <div className={classes["framerDiv2"]}>
          <img
            className={classes["framerImg"]}
            src={CarrouselSign}
            alt="carousel"
            style={{
              transition: 'opacity 0.5s ease-in-out',
              opacity: 1
            }}
          />
        </div>
        <div className={classes["framerDiv3"]}>
          <div className={classes["framerDiv4"]}>
            <img className={classes["framerImg2"]} src={PicsLogo} sizes="274px" alt="linkpick" onClick={goToHome} />
            <div className={classes["framerDiv5"]}>
              <div className={classes["framerP2"]}>Ravis de vous revoir !</div>
              <div className={classes["framerP"]}>Connectez-vous à votre compte</div>
            </div>
            <div className={classes["framerDiv6"]} />
            <div className={classes["framerDiv7"]}>
              <div className={classes["framerDiv8"]}>
                <div className={classes["framerDivLabel"]}>
                  <div className={classes["framerP3"]}>Adresse email</div>
                  {formik.touched.username && formik.errors.username && (
                    <div className={classes["framerError"]}>{formik.errors.username}</div>
                  )}
                </div>
                <TextField
                  value={formik.values.username}
                  onChange={formik.handleChange}
                  name="username"
                  error={formik.touched.username && formik.errors.username}
                />
              </div>
              <div className={classes["framerDiv8"]}>
                <div className={classes["framerDivLabel"]}>
                  <div className={classes["framerP3"]}>Mot de passe</div>
                  {formik.touched.password && formik.errors.password && (
                    <div className={classes["framerError"]}>{formik.errors.password}</div>
                  )}
                </div>
                <TextField
                  type={showPassword ? 'text' : 'password'}
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  name="password"
                  error={formik.touched.password && formik.errors.password}
                  onClick={handleClickShowPassword}
                />
              </div>
            </div>
            {/* Message d'erreur global Cognito */}
            {error && (
              <div className={classes["framerError"]}>
                {error ? cognitoErrorCodeMessage(error?.code) : '\u00A0'}
              </div>
            )}
            {/* Message d'erreur pour les mutations (Business/School) */}
            {errorMessage && (
              <div className={classes["framerError"]}>
                {errorMessage}
              </div>
            )}
            <div className={classes["framerDiv9"]}>
              <div className={classes["framerDiv10"]}>
                <Checkbox
                  checked={rememberMe}
                  onChange={(e) => setRememberMe(e.target.checked)}
                  label="Se souvenir de moi"
                />
              </div>
              <div
                className={classes["framerP5"]}
                onClick={() => setForgotPassword(true)}
              >
                Mot de passe oublié
              </div>
            </div>
            <div
              className={classes["framerButton2"]}
              onClick={formik.handleSubmit}
              disabled={isLoading}
            >
              <div className={classes["framerP6"]}>
                {isLoading ? "Chargement..." : "Se connecter"}
              </div>
            </div>
            {accType === 'individual' && (
              <>
                <div className={classes["framerDiv11"]}>
                  <div className={classes["framerDiv12"]} />
                  <div className={classes["framerP7"]}>Ou se connecter avec</div>
                  <div className={classes["framerDiv12"]} />
                </div>
                <div className={classes["framerDiv13"]}>
                  <AuthGoogleLinkedin />
                  <AuthGoogleLinkedin variant="linkedin" />
                </div>
              </>
            )}
            <div className={classes["framerP8"]}>
              Vous n'avez pas encore de compte ?
              <strong className={classes["framerText1"]} onClick={goToSignup}> Créer mon compte</strong>
            </div>
            <div className={classes["framerP8"]}>
              <span
                className={classes["framerText1"]}
                onClick={() => setViewMail(true)}
              >
                Lien de confirmation expiré ?
              </span>
            </div>
          </div>
        </div>


        <NewModal
          open={viewMail}
          onCancel={() => setViewMail(false)}
          width="400px"
          title="Lien de confirmation expiré"
          subtitle="Nous enverrons à votre adresse mail, un mail contenant un nouveau lien de confirmation de compte."
          image={{
            src: Candidate,
            alt: "mail confirmation",
            width: "110px",
          }}
          actions={[
            {
              label: "Envoyer le lien",
              onClick: mailConfirmationSubmit,
              type: "validateButton"
            }
          ]}
        >
          <MailConfirmation
            setMailConfirmationSubmit={setMailConfirmationSubmit}
            onSubmit={handleSendConfirmation}
          />
        </NewModal>

        <NewModal open={showInviteModal} onCancel={() => setShowInviteModal(false)}
          width="400px"
          image={{
            src: Candidate,
            width: "110px",
            alt: "",
          }}
          actions={[]}
          // className={classes["framerDiv14"]}
          title="Accédez à votre boite mails"
          subtitle="Afin de confirmer l'accès à votre compte : Veuillez ouvrir le mail de confirmation Linkpick."
        >
          <InviteModale />
        </NewModal>



        <NewModal
          open={forgotPassword}
          onCancel={() => {
            setForgotPassword(false);
            setStepModal(1);
            setForgotPasswordEmail('');
          }}
          width="400px"
          title="Mot de passe oublié ?"
          subtitle="Merci de saisir votre adresse mail, nous vous enverrons un code pour authentifier votre changement de mot de passe."
          image={{
            src: forgetPassword,
            alt: "forgetPassword",
            width: "110px",
          }}
          actions={[
            {
              label: stepModal === 1 ? "Recevoir le code" : "Confirmer",
              onClick: forgotPasswordSubmit,
              type: "validateButton"
            }
          ]}
        >
          <ForgotPassword
            step={stepModal}
            onNext={handleForgotPasswordNext}
            onClose={() => {
              setForgotPassword(false);
              setStepModal(1);
              setForgotPasswordEmail('');
            }}
            setForgotPasswordSubmit={setForgotPasswordSubmit}
            email={forgotPasswordEmail}
          />
        </NewModal>
      </div >
    </>
  );
}

const styles = () => {
  const { fontSizes2, colors, gap, padding, iconSizes } = linkpickTheme.params;

  return {
    "framerDiv": {
      alignItems: "center",
      backgroundColor: colors.blanc,
      display: "flex",
      flexDirection: "row",
      flexGrow: "1",
      height: "100vh",
      justifyContent: "flex-start",
      position: "relative",
      overflow: "hidden",
    },
    "framerDiv2": {
      backgroundImage: `linear-gradient(${colors.blancGlacial} 0%, ${colors.bleuPale} 100%)`,
      display: "flex",
      flexGrow: "1",
      height: "100%",
      width: "45%",
      placeItems: "center",
      justifyContent: "center",
      "@media (max-width: 810px)": {
        display: "none",
      },
    },
    "framerImg": {
      width: "45%",
    },
    "framerP": {
      ...combine(fontSizes2.bodyLg),
      fontFamily: "\"Roboto\", sans-serif",
      textAlign: "center",
      color: colors.bleuArdoise,
      width: "100%",
    },
    "framerDiv3": {
      ...combine(gap['3xl']),
      alignContent: "center",
      display: "flex",
      flexDirection: "column",
      flexGrow: "1",
      height: "min-content",
      position: "relative",
      placeItems: "center",
      overflow: "visible",
    },
    "framerDiv4": {
      ...combine(gap.xl),
      alignItems: "center",
      display: "flex",
      flexDirection: "column",
      height: "min-content",
      justifyContent: "flex-start",
      position: "relative",
      width: "550px",
      overflow: "visible",
      "@media (max-width: 1439px)": {
        width: "317px",
      },
      "@media (min-width: 1440px) and (max-width: 1542px)": {
        width: "430px",
      },
      "@media (min-width: 1543px) and (max-width: 1919px)": {
        width: "500px",
      },
      "@media (max-width: 810px)": {
        width: "100%",
        padding: "42px",
      },
    },
    "framerImg2": {
      aspectRatio: "4.38134 / 1",
      position: "relative",
      width: "274px",
      overflow: "visible",
      cursor: "pointer",
      "@media (max-width: 1439px)": {
        width: "198px",
      },
      "@media (min-width: 1440px) and (max-width: 1542px)": {
        width: "198px",
      },
      "@media (min-width: 1543px) and (max-width: 1919px)": {
        width: "230px",
      },
    },
    "framerDiv5": {
      ...combine(gap.s),
      alignItems: "center",
      display: "flex",
      flexDirection: "column",
      height: "min-content",
      justifyContent: "flex-start",
      position: "relative",
      width: "100%",
    },
    "framerP2": {
      ...combine(fontSizes2.h1),
      fontFamily: "\"Montserrat\", sans-serif",
      fontWeight: "600",
      textAlign: "center",
      color: colors.bleuMarine,
    },
    "framerDiv6": {
      backgroundColor: colors.bleuPale,
      height: "1px",
      position: "relative",
      width: "100%",
    },
    "framerDiv7": {
      ...combine(gap.xl),
      alignItems: "flex-start",
      display: "flex",
      flexDirection: "column",
      height: "min-content",
      justifyContent: "flex-start",
      position: "relative",
      width: "100%",
    },
    "framerDiv8": {
      ...combine(gap.xs),
      alignItems: "flex-start",
      display: "flex",
      flexDirection: "column",
      height: "min-content",
      justifyContent: "flex-start",
      position: "relative",
      width: "100%",
    },
    "framerP3": {
      ...combine(fontSizes2.body),
      fontFamily: "\"Roboto\", sans-serif",
      color: colors.blancGlacier,
    },
    "framerDiv9": {
      alignItems: "center",
      display: "flex",
      flexDirection: "row",
      height: "min-content",
      justifyContent: "space-between",
      position: "relative",
      width: "100%",
    },
    "framerDiv10": {
      ...combine(gap.xs),
      alignItems: "center",
      display: "flex",
      flexDirection: "row",
      height: "min-content",
      justifyContent: "flex-start",
      position: "relative",
    },
    "framerIcon7": {
      ...combine(iconSizes.iconSm),
      position: "relative",
      fill: colors.bleuElectrique,
    },
    "framerP5": {
      ...combine(fontSizes2.body),
      fontFamily: "\"Montserrat\", sans-serif",
      fontWeight: "500",
      color: colors.bleuMarine,
      cursor: "pointer",
      "&:hover": {
        textDecoration: "underline",
      },
    },
    "framerButton2": {
      ...combine(padding.s, padding.m),
      alignContent: "center",
      backgroundColor: colors.bleuElectrique,
      borderRadius: "175px",
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "center",
      height: "40px",
      position: "relative",
      width: "100%",
      cursor: "pointer",
      "&:hover": {
        backgroundColor: colors.bleuSaphir,
      },
    },
    "framerP6": {
      ...combine(fontSizes2.body),
      fontFamily: "\"Montserrat\", sans-serif",
      fontWeight: "500",
      lineHeight: "23.625px",
      textAlign: "center",
      color: colors.blanc,
    },
    "framerDiv11": {
      ...combine(gap.s),
      alignItems: "center",
      display: "flex",
      flexDirection: "row",
      height: "min-content",
      justifyContent: "flex-start",
      position: "relative",
      width: "100%",
    },
    "framerDiv12": {
      backgroundColor: colors.bleuPale,
      flexGrow: "1",
      height: "1px",
      position: "relative",
    },
    "framerP7": {
      ...combine(fontSizes2.body),
      fontFamily: "\"Montserrat\", sans-serif",
      fontWeight: "500",
      color: colors.bleuPale,
    },
    "framerDiv13": {
      ...combine(gap.s),
      alignItems: "flex-start",
      display: "flex",
      flexDirection: "row",
      height: "min-content",
      justifyContent: "flex-start",
      position: "relative",
      width: "100%",
      overflow: "visible",
    },
    "framerDiv14": {
      ...combine(gap.xxl),
      display: "flex",
      flexDirection: "column",
    },
    "framerP8": {
      ...combine(fontSizes2.body),
      fontFamily: "\"Montserrat\", sans-serif",
      fontWeight: "500",
      textAlign: "center",
      color: colors.bleuMarine,
      width: "100%",
    },
    "framerText1": {
      cursor: "pointer",
      "&:hover": {
        textDecoration: "underline",
      },
    },
    "framerDivLabel": {
      ...combine(gap.xs),
      display: "flex",
      justifyContent: "space-between",
      width: "100%",
    },
    "framerError": {
      ...combine(fontSizes2.body),
      fontFamily: "\"Roboto\", sans-serif",
      color: colors.roseElectrique,
    },
  };
};

const cognitoErrorCodeMessage = (code) => {
  switch (code) {
    case 'InvalidPasswordException':
      return 'Vos identifiants de connexion sont incorrects';
    case 'NotAuthorizedException':
      return 'Le mot de passe saisi est incorrect';
    case 'TooManyRequestsException':
      return 'Veuillez vous connecter ultérieurement';
    case 'UserNotConfirmedException':
      return 'Merci de valider votre e-mail';
    default:
      return 'Veuillez contacter le service informatique support-technique@linkpick.fr';
  }
};